import { render } from "./ReviewExtraList.component.vue?vue&type=template&id=27f8f527"
import script from "./ReviewExtraList.component.vue?vue&type=script&lang=js"
export * from "./ReviewExtraList.component.vue?vue&type=script&lang=js"

import "./ReviewExtraList.component.vue?vue&type=style&index=0&id=27f8f527&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__